import { Container, Navbar, Nav } from 'react-bootstrap';

function HeaderNavbar() {
  return (
    <Navbar bg="primary" variant="dark" expand="lg" collapseOnSelect>
      <Container>
        <Navbar.Brand href="#home">
          GraphQL with Spring Boot
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-collapse" />
        <Navbar.Collapse id="navbar-collapse">
          <Nav className="mx-auto text-center">
            <Navbar.Text className="d-block mb-2 mb-lg-0">
              Powered by:{' '}
              React Bootstrap{' '}
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/rb-logo.png`}
                width="30"
                height="30"
                className="d-inline-block align-top"
              />{' '}
              GraphQL{' '}
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/graphql-logo.png`}
                width="30"
                height="30"
                className="d-inline-block align-top"
              />{' '}
              Spring Boot{' '}
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/images/Spring Boot logo.png`}
                width="30"
                height="30"
                className="d-inline-block align-top"
              />
            </Navbar.Text>
          </Nav>
          <Nav className="ms-auto text-center">
            <Navbar.Text>
              Back-End by:{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/learning/spring-with-graphql">
                Frank P Moley III
              </a>
            </Navbar.Text>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default HeaderNavbar;
